"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobxReactLite = require("mobx-react-lite");
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native");
var _api = require("../../services/api");
var _theme = require("../../theme");
var _reactNativeUiLib = require("react-native-ui-lib");
var _DynamicForm = _interopRequireWildcard(require("../DynamicForm"));
var _DynamicTable = _interopRequireDefault(require("../DynamicTable"));
var _native = require("@react-navigation/native");
var _reactNativeSvg = _interopRequireWildcard(require("react-native-svg"));
var _expoLinearGradient = require("expo-linear-gradient");
var _reactNativeShadow = require("react-native-shadow");
var _state = require("../state");
var _FormScreen = _interopRequireDefault(require("./FormScreen"));
var _reactRouterDom = require("react-router-dom");
var _antd = require("antd");
var _reactNativeEvaIcons = require("react-native-eva-icons");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// 

var LayoutScreen = (0, _mobxReactLite.observer)(function LayoutScreen(props) {
  var _useStores = (0, _state.useStores)(),
    _useStores$modalStore = _useStores.modalStore,
    getOpenModals = _useStores$modalStore.getOpenModals,
    setOpenModal = _useStores$modalStore.setOpenModal,
    _useStores$layoutStor = _useStores.layoutStore,
    isSideBarCollapsed = _useStores$layoutStor.isSideBarCollapsed,
    toggleSideBarCollapsed = _useStores$layoutStor.toggleSideBarCollapsed,
    getSideBarPosition = _useStores$layoutStor.getSideBarPosition,
    setSideBarPosition = _useStores$layoutStor.setSideBarPosition;
  return /*#__PURE__*/_react["default"].createElement(_reactNativeUiLib.View, {
    flex: true,
    row: _reactNative.Platform.OS == 'web' && getSideBarPosition == 'left',
    style: {
      height: _reactNative.Dimensions.get('window').height
    }
  }, props.children);
});
var _default = exports["default"] = LayoutScreen;
var $container = {
  flex: 1
};